module.exports = __webpack_public_path__ + "static/media/Home_Products_02.55031841.png";